import React, { useEffect, useState } from 'react';

/**
 * Real end of the offer (ISO date, e.g. '2026-10-31T23:59:59+01:00').
 * While null, the bar shows a rolling 15-minute countdown.
 */
const OFFER_ENDS_AT: string | null = null;
const FALLBACK_SECONDS = 15 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
function getRemaining(fallbackStart: number): number {
  if (OFFER_ENDS_AT) {
    return Math.max(0, Math.floor((new Date(OFFER_ENDS_AT).getTime() - Date.now()) / 1000));
  }
  const elapsed = Math.floor((Date.now() - fallbackStart) / 1000);
  return FALLBACK_SECONDS - elapsed % FALLBACK_SECONDS;
}
export function CountdownBar() {
  const [start] = useState<number>(() => Date.now());
  const [remaining, setRemaining] = useState<number>(() => getRemaining(start));
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining(start)), 1000);
    return () => window.clearInterval(id);
  }, [start]);
  if (remaining <= 0) return null;
  const days = Math.floor(remaining / 86400);
  const hours = Math.floor(remaining % 86400 / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [...(days > 0 ? [{
    value: days,
    suffix: '日'
  }] : []), ...(days > 0 || hours > 0 ? [{
    value: hours,
    suffix: '時'
  }] : []), {
    value: minutes,
    suffix: '分'
  }, {
    value: seconds,
    suffix: '秒'
  }];
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="1r3lefdx1e7s2">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="1dcgdm8hxn9g5">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="1hcqjzm9n01vj">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-300 opacity-60 motion-reduce:animate-none" data-id="element-59" data-mp="252umtrf03xlh" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-60" data-mp="29vnou7j34rtv" />
        </span>
        <span className="text-stone-50/80" data-id="element-61" data-mp="2jpjjzmls5yop">
          <span className="hidden sm:inline" data-id="element-62" data-mp="2fohqznigiiv6">限時優惠，尚餘</span>
          <span className="sm:hidden" data-id="element-63" data-mp="2fozpyrwi7b6s">優惠尚餘</span>
        </span>
        <span className="flex items-baseline gap-2 font-semibold tabular-nums" aria-live="off" data-id="element-64" data-mp="2aolq3x5237ju">
          {units.map(unit => <span key={unit.suffix} className="flex items-baseline gap-0.5" data-id="element-65" data-mp="25p8uoo04cs5n">
              <span className="text-stone-50" data-id="element-66" data-mp="20rqov6heet1v">{pad(unit.value)}</span>
              <span className="text-xs font-medium text-stone-50/60" data-id="element-67" data-mp="20t1sn6aug0sz">{unit.suffix}</span>
            </span>)}
        </span>
      </div>
    </div>;
}